/*
 * @Descripttion: 交集
 * @version: 
 * @Author: xutingting
 * @Date: 2021-05-13 13:59:35
 * @LastEditors: xutingting
 * @LastEditTime: 2021-12-15 15:08:30
 */
import React, { useState } from 'react';
import { Input, Button, Form } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import styles from '../../../index.module.scss';

export default ({allNodeData = [], prevNodes = [], initData = {}, runState = {}, currentNode = {}, changeData = (data) => {}, onCancel = () => {}, validate = () => {}, getAllNodeIds = []}) => {

  // 组件内部的数据
  const [data, setData] = useState({
    ...initData
  })

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    })
  }

  /**
   * 点击确认
   */
  const confirm = async () => {
    try {
      await Promise.all(Object.keys(validate).map(async validator => {
        // 最终校验数据是否填写完整，然后提交给全局
        try {
          if (validator in data) {
            if (validator === 'name') {
              await validate[validator](data[validator], allNodeData, currentNode, getAllNodeIds);
            } else {
              await validate[validator](data[validator]);
            }
          }
        } catch (e) {
          throw new Error(e);
        }
      }));
      changeData(data);
    } catch (e) {
      LzMsg.error(e.message);
    }
  };

  /**
   * 点击退出
   */
  const cancel = () => {
    onCancel()
  }

  const formItemLayout = {
    labelCol: {
      span: 5
    },
  };

  return (
    <div>
      <div style={{display: prevNodes.length >= 2 ? "none" : "block"}} className={styles['warning-text']}>{prevNodes.length ===1 ? '上级节点至少连接2个' : '请先连接上级节点'}</div>
      <Form className={`${styles.formDiv} ${styles.extractDiv} canvasDialog`} {...formItemLayout}>
        <Form.Item label="节点名称:" required requiredMessage="请输入节点名称" style={{padding: '30px 30px 0 30px'}}>
          <Input className={`formItemWidth`} name="extractName" placeholder="请输入节点名称" trim size="small" value={data.name} onChange={(name) => onChange({ name })} showLimitHint maxLength={24}/>
        </Form.Item>
        <Form.Item label="备注:" style={{padding: '0 30px'}}>
          <Input.TextArea className={`formItemWidth`} name="remark" placeholder="请输入备注" trim size="small" value={data.remark} onChange={(remark) => onChange({ remark })} showLimitHint maxLength={150}/>
        </Form.Item>
        <hr />
        <div style={{padding: '15px 30px 0 0', height:'60px'}}>
        <Button type="primary" className={`submit-btn ${styles.w88}`} onClick={confirm} style={{float:'right'}}>确认</Button>
          <Button type="normal" className={`cancel-btn ${styles.mr10} ${styles.w88}`} onClick={cancel} style={{float:'right'}}>取消</Button>
        </div>
      </Form>
    </div>
  )
}